import type { AutoGeneratorForFormModel } from "@/components/features/_model/types/auto-generator-for-form-model";

import type { VoucherI18nInputSchema } from "./validation-schema";

const _excludeKeys = ["hotelID", "voucherID", "lang"] as const;
export const excludeKeys = _excludeKeys.map((key) => key);
export type ExcludeKeys = (typeof excludeKeys)[number];

export type MarketingVoucherI18nFormModel = AutoGeneratorForFormModel<VoucherI18nInputSchema, ExcludeKeys, QueryData>;

export type QueryData = undefined;
